var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Users from '@mui/icons-material/SupervisedUserCircleRounded';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSnackbar } from 'notistack';
import React, { useCallback, useState } from 'react';
import { emptyList, useApiFetch } from '../../../Api';
import { useApiAbort } from '../../../Api/Core/useApiAbort';
import EmailField from '../../../Components/Field/EmailField';
import GoBack from '../../../Components/GoBack/GoBack';
import Header from '../../../Components/Header/Header';
import TableMessage from '../../../Components/TableMessage';
import Wrapper from '../../../Components/Wrapper/Wrapper';
import { useApi } from '../../../Context/APIContext';
import { MakhazinTheme } from '../../../theme';
import { useStyles } from './StorageUsers.styles';
const fetchStorageUsers = (storageId, api) => __awaiter(void 0, void 0, void 0, function* () {
    if (api) {
        const response = yield api.getStorageUsers(storageId);
        return response.users;
    }
    else {
        return [];
    }
});
export const StorageUsers = (props) => {
    const smDown = useMediaQuery(MakhazinTheme.breakpoints.down('sm'));
    const classes = useStyles();
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [inviteDialog, setInviteDialog] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState();
    const [deleteInviteId, setDeleteInviteId] = useState();
    const { enqueueSnackbar } = useSnackbar();
    const [inviteEmail, setInviteEmail] = useState('');
    const api = useApi();
    const abortController = useApiAbort();
    if (api) {
        api.setAbortController(abortController.current);
    }
    const [storageUsers] = useApiFetch(useCallback(() => {
        return fetchStorageUsers(props.storageId, api) || Promise.resolve(undefined);
    }, [api, props.storageId]), undefined, emptyList, abortController.current);
    const initiateInvite = () => {
        setInviteEmail('');
        setInviteDialog(true);
    };
    const initiateRemove = (userId, inviteId) => {
        setDeleteInviteId(inviteId);
        setDeleteUserId(userId);
        setConfirmDialog(true);
    };
    const deleteUser = (userId) => __awaiter(void 0, void 0, void 0, function* () {
        if (api) {
            try {
                yield api.deleteStorageUser(props.storageId, userId);
                enqueueSnackbar('Användaren kommer inte längre åt förrådsutrymmet', { variant: 'success' });
            }
            catch (_) {
                enqueueSnackbar('Något gick fel', { variant: 'error' });
            }
        }
        if (abortController.current.signal.aborted) {
            return;
        }
        setConfirmDialog(false);
    });
    const deleteInvite = (inviteId) => __awaiter(void 0, void 0, void 0, function* () {
        if (api) {
            try {
                yield api.deleteStorageUserInvitation(props.storageId, inviteId);
                enqueueSnackbar('Inbjudan borttagen', { variant: 'success' });
            }
            catch (_) {
                enqueueSnackbar('Något gick fel', { variant: 'error' });
            }
        }
        if (abortController.current.signal.aborted) {
            return;
        }
        setConfirmDialog(false);
    });
    const inviteUser = () => __awaiter(void 0, void 0, void 0, function* () {
        if (api) {
            try {
                yield api.inviteStorageUser(props.storageId, inviteEmail);
                enqueueSnackbar('Användaren inbjuden', { variant: 'success' });
            }
            catch (_) {
                enqueueSnackbar('Något gick fel. Användaren blev inte inbjuden', { variant: 'error' });
            }
        }
        if (abortController.current.signal.aborted) {
            return;
        }
        setInviteDialog(false);
    });
    const noUsersIsInvited = !storageUsers || storageUsers.length === 0;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { fullwidth: true },
            React.createElement(GoBack, { to: `/mypages/mystorage/${props.storageId}` }),
            React.createElement(Typography, { variant: "h1", sx: classes.title }, "Anv\u00E4ndare"),
            React.createElement(Button, { onClick: initiateInvite, variant: "outlined", sx: classes.button }, "Bjud in anv\u00E4ndare")),
        React.createElement(Wrapper, null,
            React.createElement(Box, { sx: classes.tableWrapper },
                !smDown ? (React.createElement(Table, null,
                    React.createElement(TableHead, null,
                        React.createElement(TableRow, null,
                            React.createElement(TableCell, null, "F\u00F6rnamn"),
                            React.createElement(TableCell, null, "Efternamn"),
                            React.createElement(TableCell, null, "E-mail"),
                            React.createElement(TableCell, null, "Inbjudan accepterad"),
                            React.createElement(TableCell, null))),
                    React.createElement(TableBody, null, storageUsers &&
                        storageUsers.map(user => (React.createElement(TableRow, { key: user.email },
                            React.createElement(TableCell, null, user.firstName || user.invitationFirstName),
                            React.createElement(TableCell, null, user.lastName || user.invitationLastName),
                            React.createElement(TableCell, null, user.email || user.invitationEmail),
                            React.createElement(TableCell, null, user.email ? 'Ja' : 'Nej'),
                            React.createElement(TableCell, { align: "right" },
                                React.createElement(Tooltip, { title: "Ta bort anv\u00E4ndare" },
                                    React.createElement(IconButton, { onClick: () => initiateRemove(user.userId, user.invitationId), sx: classes.removeuser, "aria-label": "Ta bort anv\u00E4ndare" },
                                        React.createElement(DeleteIcon, null)))))))))) : (React.createElement(Box, { component: "div", sx: classes.container }, storageUsers &&
                    storageUsers.map(user => (React.createElement(Box, { component: "div", sx: classes.user, key: user.email },
                        React.createElement(Box, { component: "div", sx: classes.infoContainer },
                            React.createElement(Box, { component: "span", sx: classes.activityName },
                                user.firstName || user.invitationFirstName,
                                ' ',
                                user.lastName || user.invitationLastName),
                            React.createElement("span", null, user.email || user.invitationEmail)),
                        React.createElement("div", null,
                            React.createElement(IconButton, { onClick: () => initiateRemove(user.userId, user.invitationId), sx: classes.removeuser, "aria-label": "Ta bort anv\u00E4ndare" },
                                React.createElement(DeleteIcon, null)))))))),
                (noUsersIsInvited && (React.createElement(TableMessage, { text: "Du har inte bjudit in n\u00E5gra anv\u00E4ndare", icon: React.createElement(Users, { fontSize: "large" }) }))) || React.createElement(React.Fragment, null),
                React.createElement(Dialog, { "aria-label": "Bjud in anv\u00E4ndare", open: inviteDialog },
                    React.createElement(DialogContent, null,
                        React.createElement(Typography, null, "Bjud in anv\u00E4ndare"),
                        React.createElement(EmailField, { label: "", value: inviteEmail, onChange: value => setInviteEmail(value || '') }),
                        React.createElement(Grid, { container: true, direction: "row", justifyContent: "space-between" },
                            React.createElement(Button, { variant: "outlined", onClick: () => setInviteDialog(false) }, "Avbryt"),
                            React.createElement(Button, { variant: "contained", disabled: inviteEmail === '', color: "primary", onClick: inviteUser }, "Bjud in")))),
                React.createElement(Dialog, { "aria-label": "Ta bort anv\u00E4ndare", open: confirmDialog },
                    React.createElement(DialogContent, null,
                        React.createElement(Typography, null, "\u00C4r du s\u00E4ker att du vill ta bort denna anv\u00E4ndaren?"),
                        React.createElement("div", { className: `${classes.buttonContainer} ${classes.deleteUserDialogContainer}` },
                            React.createElement(Button, { variant: "outlined", onClick: () => setConfirmDialog(false) }, "Avbryt"),
                            React.createElement(Button, { variant: "contained", sx: classes.deleteBtn, onClick: () => deleteUserId ? deleteUser(deleteUserId) : deleteInvite(deleteInviteId) }, "Ta bort"))))))));
};
export default StorageUsers;
